import accounting from './accounting.json'
import addressing from './addressing.json'
import auth from './auth.json'
import customers from './customers.json'
import dashboard from './dashboard.json'
import errors from './errors.json'
import general from './general.json'
import invoices from './invoices.json'
import items from './items.json'
import matomo from './matomo.json'
import projects from './projects.json'
import quotes from './quotes.json'
import subscription from './subscription.json'
import tables from './tables.json'
import timeTracking from './timeTracking.json'

export { accounting, addressing, auth, customers, dashboard, errors, general, items, matomo, projects, invoices, quotes, subscription, tables, timeTracking }
